<div class="banner-pronto-pago">
  <div class="banner-pronto-pago__brillo"></div>
  <div class="banner-pronto-pago__contenido">
    <div class="banner-pronto-pago__texto">
      <span class="chip-oferta" *ngIf="!ContentBannerProntoPago['aceptaOferta']">{{ ContentBannerProntoPago['chip'] }}</span>
      <h3 class="banner-pronto-pago__titulo"
          [class.banner-pronto-pago__titulo--sin-chip]="ContentBannerProntoPago['aceptaOferta']">{{ ContentBannerProntoPago['title'] }}</h3>
      <p class="banner-pronto-pago__detalle" [innerHTML]="ContentBannerProntoPago.body"></p>
    </div>
    <div class="banner-pronto-pago__cta">
      <app-button Theme="button-primary"
                  [Label]="'<p>' + ContentBannerProntoPago.cta + ' →</p>'"
                  [IcoSvg]="null"
                  (click)="abrirProntoPago()"></app-button>
    </div>
  </div>
</div>
